import { render, staticRenderFns } from "./Sign.vue?vue&type=template&id=1d920470&scoped=true"
import script from "./Sign.vue?vue&type=script&lang=js"
export * from "./Sign.vue?vue&type=script&lang=js"
import style0 from "../assets/css/sign.css?vue&type=style&index=0&id=1d920470&prod&scoped=true&lang=css&external"
import style1 from "./Sign.vue?vue&type=style&index=1&id=1d920470&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d920470",
  null
  
)

export default component.exports